import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { CategoryDialogs } from '../../constants/Dialogs';

import { MuiTreeList } from 'react-treeview-mui';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

import CategoryActions from '../../actions/CategoryActionCreator';
import CategoryStore from '../../stores/CategoryStore';
import DialogStore from '../../stores/DialogStore';
import DialogActions from '../../actions/DialogActionCreator';

const initialState = {
    categories: [],
    activeIndex: null,
    activeName: '',
    categoryName: '',
    categoryId: null
};

const formatCategories = (categoryTree) => {
    if (!categoryTree || !categoryTree.length) { return []; } //guard

    //List items presented to MuiTreeList as a flattened tree with the elements in the correct order or else it misbehaves
    let categories = [{
        id: 0,
        name: '(None)',
        depth: 1,
    }];
    const addChildren = (category) => {
        categories.push({id: category.id, name: category.name, parentId: category.parentId, depth: category.level + 1});
        category.children.forEach(addChildren);
    }
    categoryTree.forEach(addChildren);

    categories.forEach((cat) => {
        if (!!cat.parentId) {
            cat.parentIndex = categories.findIndex(({id}) => id === cat.parentId);
        }
        const children = categories
            .filter((el) => !!el && el.parentId === cat.id)
            .map((ch) => categories.findIndex(({id}) => id === ch.id));
        if (!!children.length) {
            cat.children = children;
        }
    });

    return categories;
}


class CategorySelector extends Component {

    constructor() {
        super(...arguments);

        this.state = {
            ...initialState,
            categoryId: this.props.defaultCategoryId || null
        };
    }

    componentDidMount() {
        this.onSelect = this.onSelect.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onConfirmSelection = this.onConfirmSelection.bind(this);
        this.onCategoriesChange = this.onCategoriesChange.bind(this);

        this.listener = CategoryStore.addListener(this.onCategoriesChange);
        CategoryActions.listByMyOrganisation(this.props.options);
    }

    componentWillReceiveProps(nextProps) {
        if (!!nextProps.defaultCategoryId && (nextProps.defaultCategoryId !== this.props.defaultCategoryId || !this.state.categoryId)) {
            const category = CategoryStore.getById(nextProps.defaultCategoryId);
            this.setState({
                categoryId: nextProps.defaultCategoryId,
                categoryName: !!category ? category.name : ''
            });
        }
    }

    componentWillUnmount() {
        this.listener.remove();
    }

    render() {
        return (
            <div>
                <TextField
                    name="categoryName"
                    value={this.state.categoryName}
                    floatingLabelText="Category"
                    inputStyle={{color: 'rgb(0, 0, 0, 0.33) !important'}}
                    fullWidth
                    disabled
                />
                <FlatButton label="Select" onTouchTap={() => DialogActions.open(CategoryDialogs.SELECT)} primary />
                <Dialog
                    modal={false}
                    open={this.state.openDialog === CategoryDialogs.SELECT}
                    title="Select category"
                    onRequestClose={this.onCancel}
                    autoScrollBodyContent
                    bodyStyle={{borderTop: 0, borderBottom: 0}}
                    actions={[
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this.onCancel} />,
                        <FlatButton key="select" label="Select" onTouchTap={this.onConfirmSelection} disabled={!this.state.activeName} primary />
                    ]}
                >
                    <MuiTreeList
                        contentKey={'name'}
                        activeListItem={this.state.activeIndex}
                        handleTouchTap={this.onSelect}
                        handleTouchTapInSearchMode={this.onSelect}
                        listItems={this.state.categories}
                        haveSearchbar
                    />
                </Dialog>
            </div>
        );
    }

    onSelect(cat, i) {
        if (!!this.props.onSelect) {
            this.props.onSelect(cat, i);
        }
        this.setState({activeIndex: i, activeName: cat.name, categoryId: cat.id});
    }

    onConfirmSelection() {
        const noneSelected = this.state.activeIndex === 0;
        if (!!this.props.onConfirmSelection) {
            this.props.onConfirmSelection(noneSelected ? null : this.state.categoryId);
        }
        this.setState({categoryName: noneSelected ? '' : this.state.activeName});
        DialogActions.close();
    }

    onCancel() {
        if (!!this.props.onCancel) {
            this.props.onCancel();
        }
        this.setState({activeIndex: null, activeName: null});
        DialogActions.close();
    }

    onCategoriesChange() {
        let changes = null;
        if (this.state.categoryId) {
            const category = CategoryStore.getById(this.state.categoryId);
            if (!!category) {
                changes = {categoryId: this.state.categoryId, categoryName: category.name};
            }
        }
        const categoryTree = CategoryStore.getTree();
        if (!!categoryTree) {
            changes = {...changes, categories: formatCategories(categoryTree)};
        }
        if (!!changes) {
            this.setState(changes);
        }
    }
}

CategorySelector.getStores = () => [DialogStore];
CategorySelector.calculateState = (prevState) => ({
    ...(prevState || initialState),
    openDialog: DialogStore.getOpenDialog()
})
CategorySelector.propTypes = {
    defaultCategoryId:  PropTypes.number,
    onSelect:           PropTypes.func,
    onConfirmSelection: PropTypes.func,
    onCancel:           PropTypes.func,
    options:            PropTypes.object,
};

export default Container.create(CategorySelector, {withProps: true});
